<template>
	<div id="enterprise_detail">
		<leftnav class="fl"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
		<div class="index_left_centerpage">
		<div class="enterprise_detail">
			<div class="whitebox " :class="userdata.userType == 2?'centerpage':''"> 
				<div class="d_blocktitle">
					<i class="title-icon title-icon1"></i>
					<h3 class="ctitle">{{companyinfor.title}}</h3> 
					<!-- <span v-if="companyinfor.fullName!=''">（{{companyinfor.fullName}}）</span> -->
					<span :class="companyinfor.collectId == 0?'collectbtn add fr':'collectbtn remove fr'" @click="collectFun()">{{companyinfor.collectId == 0?'+添加关注':'取消关注'}}</span>
				</div>
				<ul class="oh conpany-infor-new">
					<li class="inforLine inforLine-3"><span class="label">所属地区：</span><span class="infortext">{{companyinfor.country}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">行 业：</span><span class="infortext">{{companyinfor.industry}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">交易平台：</span><span class="infortext">{{companyinfor.exchangeTrans}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">板块：</span><span class="infortext">{{companyinfor.plate}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">股票代码：</span><span class="infortext">{{companyinfor.stockCode}}</span> </li>
					<li class="inforLine inforLine-3"><span class="label">员工人数：</span><span class="infortext">{{companyinfor.employee}}</span> </li>
					<li class="inforLine inforLine-one" v-show="companyinfor.summary!=''"><span class="label">公司简介：</span><span class="infortext">{{companyinfor.summary}}</span> </li>
				</ul> 
			</div>
	<!-- 		<div class="de_floorlist1 ende_floorlist" :style="userdata.userType ==1?'width:100%':''">
				<div class="ende_floorlistfixed">
					<ul class="oh">
						<li class="floorlistLi" v-show="companyinfor.insurePerson>0" @click="floorscroll(0)">联系方式</li>
						<li class="floorlistLi" v-show="companyinfor.notion!=''" @click="floorscroll(1)">投资领域</li>
						<li class="floorlistLi" @click="floorscroll(2)">投资机构画像</li>
						<li class="floorlistLi" @click="floorscroll(3)">投资事件</li>
					</ul> 
			</div> 
			</div> -->
			<div class="whitebox company-contact" > 
					<div class=" d_blocktitle d-floortitle">
						<i class="title-icon title-icon2"></i>
						<h3 class="title">联系方式</h3>
					</div>
					<ul class="oh conpany-infor-new">
						<li class="inforLine inforLine-3"><span class="label">联系电话：</span><span class="infortext">{{companyinfor.phone}}</span> </li>
						<li class="inforLine inforLine-3"><span class="label">传真：</span><span class="infortext">{{companyinfor.fax}}</span> </li>
						<li class="inforLine inforLine-3 com_website">
							<span class="label">网 址：</span>
							<span v-if="companyinfor.website.length>3"  @click="rwebsite=true" class="curp infortext">{{enterpriseWebsite}}</span> 
							<span class="infortext" v-if="companyinfor.website.length<4">{{companyinfor.website}}</span>
						</li>
						<li class="inforLine inforLine-one"><span class="label">联系地址：</span><span class="infortext">{{companyinfor.address}}</span> </li> 
					</ul> 
					<div class="enprise_websitebox" v-show="rwebsite" @click="rwebsite=false">
						<div class="enprise_website">
							<h2>您即将跳转进入第三方网站</h2>
							<p class="website_tips"><b>产业大脑</b>不对该网站内容及真实性负责，请注意您的账户和财产安全</p>
							<p class="website_text"><a :href="enterpriseWebsite"  target="_blank">{{enterpriseWebsite}}</a></p>
							<a class="router_website" :href="enterpriseWebsite" target="_blank">继续前往</a>
						</div>
					</div>  
			</div>
			<div class="whitebox company-investinfor" v-show="othertransList.length>0">
				<div class="d_blocktitle d-floortitle"  >
					<i class="title-icon title-icon3"></i>
					<h3 class="title">其他交易平台</h3>
				</div>
				<div class="oh">
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
						<tr>
							<th>名称</th>
							<th>代码</th>
							<th>交易平台</th> 
							<th>板块</th>
							<th>行业</th>
							<th>员工人数</th> 
						</tr> 
						 <tr v-for="(list,index) in othertransList" >
						 	<!-- <td>{{(page-1)*pageSize+index+1}}</td> -->
								<td>{{list.title}}</td>
						 	<td>{{list.stockCode}}</td>
						 	<td>{{list.exchangeTrans.length>0?list.exchangeTrans:'-'}}</td>
						 	<td>{{list.plate.length>0?list.plate:'-'}}</td>
						 	<td>{{list.industry.length>0?list.industry:'-'}}</td>
						 	<td>{{list.employee}}</td> 
						 </tr>
					</table> 
					
					
				</div>
			</div>
			<div class="whitebox company-investinfor" v-show="profitData.date.length>0" >
				<div class="d_blocktitle d-floortitle"  >
					<i class="title-icon title-icon8"></i>
					<h3 class="title">经营情况</h3>
				</div>
				<div class="oh ">
					<div class="condition_bar w95mg oh">
						<div class="echartbox fl" :style="'width:'+echartWidth2+'px;'" id="condition_bar1" v-show="conditionBar1Data.noEmpty1"></div>
						<div class="echartbox fr" :style="'width:'+echartWidth2+'px;'" id="condition_bar2" v-show="conditionBar2Data.noEmpty1"></div>
					</div>
					<div class="w95mg">
						<h4 class="endsm_title">利润表 <span class="fwn" style="margin-left:20px">（单位：百万{{profitData.unit}}）</span></h4>
					</div> 
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" width="100%">
						<tr>
							<!-- <th class="xuhaotd">序号</th> -->
							<th></th>
							<th v-for="date in profitData.date" style="font-weight: bold;">{{date}}</th>  
						</tr>
						<!-- v-show="item.noEmpty" -->
						<tr v-for="(item,index) in profitData.list"  v-show="item.noEmpty">
							<!-- <td>{{index+1}}</td> -->
							<!--  类型{{item.type}} -->
							<td style="width:200px;"><h5 :class="{'profitTitle':true,'blackt':item.type==4 && item.showchildren,'blackb':item.type==4 && !item.showchildren,'fwn':item.bold!=1, 'smProfitTitle':item.type==2}" @click="showChildrenInfor('利润表',item)">{{item.text}}</h5></td>
							<td v-for="val in item.value">  
							<span>{{val!=0?val:'-'}}</span> 
							</td> 
						</tr> 
					</table>
					<div class="w95mg">
						<h4 class="endsm_title">资产负债表 <span class="fwn" style="margin-left:20px">（单位：百万{{debtData.unit}}）</span></h4>
					</div> 
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" width="100%">
						<tr>
							<!-- <th class="xuhaotd">序号</th> -->
							<th></th>
							<th v-for="date in debtData.date" style="font-weight: bold;">{{date}}</th>  
						</tr>
						<!-- v-show="item.noEmpty" -->
						<tr v-for="(item,index) in debtData.list"  v-show="item.noEmpty">
							<!-- <td>{{index+1}}</td> -->
							<!--  类型{{item.type}} -->
							<td style="width:200px;"><h5 :class="{'profitTitle':true,'blackt':item.type==4 && item.showchildren,'blackb':item.type==4 && !item.showchildren,'fwn':item.bold!=1, 'smProfitTitle':item.type==2}" @click="showChildrenInfor('资产负债表',item)">{{item.text}}</h5></td>
							<td v-for="val in item.value">  
							<span>{{val!=0?val:'-'}}</span> 
							</td> 
						</tr> 
					</table>
					<div class="w95mg">
						<h4 class="endsm_title">现金流量表 <span class="fwn" style="margin-left:20px">（单位：百万{{cashData.unit}}）</span></h4>
					</div> 
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" width="100%">
						<tr>
							<!-- <th class="xuhaotd">序号</th> -->
							<th></th>
							<th v-for="date in cashData.date" style="font-weight: bold;">{{date}}</th>  
						</tr>
						<!-- v-show="item.noEmpty" -->
						<tr v-for="(item,index) in cashData.list"  v-show="item.noEmpty">
							<!-- <td>{{index+1}}</td> -->
							<!--  类型{{item.type}} -->
							<td style="width:200px;">
								<h5 :class="{'profitTitle':true,'blackt':item.type==4 && item.showchildren,'blackb':item.type==4 && !item.showchildren,'fwn':item.bold!=1, 'smProfitTitle':item.type==2}" @click="showChildrenInfor('现金流量表',item)">{{item.text}}</h5></td>
							<td v-for="val in item.value">  
							<span>{{val!=0?val:'-'}}</span> 
							</td> 
						</tr> 
					</table>
				</div> 
			</div>
		</div>
		</div>
		</div>
		<footerbar v-if="userdata.userType >1"></footerbar>
	</div>
</template>

<script>
	import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'institutionDetail',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				curindex: 5,
				searchtype:6,enterpriseWebsite:"",
				guidepage:'境外上市企业详情页',echartWidth2:document.body.offsetWidth*0.8728*0.95*0.48,
				userdata:{},othertransList:[],conditionBar1Data:{value:[0,0,0,0],noEmpty1:false},conditionBar2Data:{value:[0,0,0,0],noEmpty1:false,},
				enterpriseid: 0,profitData:{date:[],list:[],unit:""},debtData:{date:[],list:[],unit:""},cashData:{date:[],list:[],unit:""},
				companyinfor: {title:"",industry:"",block:"", certificatetype:'','insurePerson':0,summary:"",adress:"",phone:"",website:"",portno:""}, 
				floorlist: ['联系方式', '投资领域','投资事件'], 
				rwebsite:false,barHeight:60,
			}
		},  
		beforeCreate() {
				
		},
		created() {
			this.$nextTick(() => {
					// 禁用右键
					document.oncontextmenu = new Function("event.returnValue=false");
					// 禁用选择
					document.onselectstart = new Function("event.returnValue=false");
			}); 
			// window.scrollTo(0,0);
			this.bus.$emit('loading',true);
			this.enterpriseid = this.$route.query.id; 
			var _this=this;
			this.userdata = this.getuseriformation();
	  // console.log(this.enterpriseid)
			this.getForeigEnDetail(this.enterpriseid);
			
		},
		mounted() {
			window.scrollTo(0, 0);  
			// window.addEventListener("scroll", this.handleScroll, true);  
				
			// var timer=setTimeout(function(){
			// 	for(var i=0;i<document.getElementsByClassName('d-floortitle').length;i++){
			// 		console.log(document.getElementsByClassName('d-floortitle').length,i,document.getElementsByClassName('d-floortitle')[i])
			// 	}
				
			// },5000);
			
		},
		methods: { 
		//判断企业网址是否符合标准 长度大于4并且要有http
		getEnterpriseWebsite(str){
			// console.log('str',str)
			if(str.length>3){
				if(str.indexOf('http')<0){
					str='http://'+str;
				}  
			}
			this.enterpriseWebsite=str; 
		}, 
			//添加删除收藏
			collectFun(){
				// console.log(this.companyinfor.collectId,this.companyinfor);
				this.listToggleCollect(this.companyinfor,'acoc') 
			},
			//获取境外上市企业详情页
			getForeigEnDetail(id){
				var ajaxurl=this.$api.cyl.foreignenterprise.detail()+'?id='+id;
				var _this=this;
				this.getAxiosData(ajaxurl,this.userdata.token,function(res){
					// console.log('境外上市企业详情页'+id,res); 
					_this.companyinfor=res.data;
					_this.getEnterpriseWebsite(res.data.website);
					document.title = res.data.title;
					_this.othertransList=res.list.filter(list=>{
						return list.id!=_this.enterpriseid;
					});
					_this.getTableList1('利润表',res.extend.profit)
					_this.getTableList1('资产负债表',res.extend.debt);
					_this.getTableList1('现金流量表',res.extend.cash);
					_this.bus.$emit('loading',false);
					// console.log('境外上市企业详情页的利润表',lindata.list)
					// setTimeout(function(){
					// 	_this.barHeight=document.getElementsByClassName('ende_floorlist')[0].offsetHeight;
					// 	console.log(_this.barHeight)
					// },1000)
					
					// _this.paramList=res.data;
					// _this.getForeignEnList();
				})
			}, 
			getTableList1(name,listdata){
				let lindata=listdata;  //利润表的数据处理
				var _this=this;
				//做一个判断数值是否都为空的函数 
				for(var d=0;d<lindata.list.length;d++){
					let valuedata=lindata.list[d].value; 
					lindata.list[d].noEmpty=true; 
					if(lindata.list[d].type == 1){
						lindata.list[d].bold=1
					}else{
						lindata.list[d].bold=2
					}
					if(lindata.list[d].type!=2){
						lindata.list[d].children=[];
						lindata.list[d].showchildren=true;
						//当前参数为非子信息时 判断数值是否都为空 暂停
						
						if(lindata.list[d].text == "总收入"){
						 _this.conditionBar1Data=lindata.list[d];
						 _this.conditionBar1Data.date=lindata.date;
						 _this.conditionBar1Data.unit=lindata.unit;
							_this.jinliruBar('condition_bar1',_this.conditionBar1Data); 
						}else if(lindata.list[d].text == "营业利润"){
							_this.conditionBar2Data=lindata.list[d];
							_this.conditionBar2Data.date=lindata.date;
							_this.conditionBar2Data.unit=lindata.unit; 
							_this.jinliruBar('condition_bar2',_this.conditionBar2Data); 
						} 
					}else{
						// lindata.list[d].noEmpty=true;
						let parentname=lindata.list[d].parentName;
					 for(var s=0;s<lindata.list.length;s++){
							if(parentname == lindata.list[s].name){ 
								lindata.list[s].children.push(d);
								lindata.list[s].type=4;
								lindata.list[d].noEmpty=lindata.list[s].showchildren;
							}  
						} 
					} 
				} 
				//将利润表d的类型为1的children里存入底下类型为2的index值 通过控制index值来显示下层信息
				// console.log(name,lindata)
				if(name == '利润表'){
					_this.profitData=lindata; 
				}else if(name == "资产负债表"){
					_this.debtData=lindata;
				}else if(name == "现金流量表"){
					_this.cashData=lindata;
				}
			},
			//点击利润表的第一级信息 显示第二级信息
			showChildrenInfor(name,data){
				if(data.type == 4){
					data.showchildren=!data.showchildren;
					// console.log(data.children)
					for(var d=0;d<data.children.length;d++){ 
						let ind=data.children[d];
						if(name == '利润表'){
							// console.log(this.profitData.list[ind].text,data.showchildren)
							this.profitData.list[ind].noEmpty=data.showchildren;
						}else if(name == "资产负债表"){
							// console.log(this.debtData.list[ind].text,data.showchildren)
							this.debtData.list[ind].noEmpty=data.showchildren;
						}else if(name == "现金流量表"){
							this.cashData.list[ind].noEmpty=data.showchildren;
						}
					
					} 
				}
			},
			//营业收入echarts表格
			jinliruBar($el,data){ 
				let valuedata=data.value;
				data.noEmpty1=false;
			 for(var t=0;t<valuedata.length;t++){
			 	if(valuedata[t] != 0){
			 	data.noEmpty1=true;
			 	}
			 }
				if(!	data.noEmpty1){ 
					return;
				}  
				var chart = echarts.init(document.getElementById($el));
				var _this = this;  
				var date1=[]; var value1= [];
				for(var i=0;i<data.date.length;i++){
					date1.unshift(data.date[i]);
					value1.unshift(data.value[i]);
				}  
				let option = {
					title:{
						text:data.text,bottom:5,left:'center',
						textStyle:{fontWeight:"normal",fontSize:16}
					},
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
						color: '#000',
						fontSize: 14, 
						}, 
						formatter: function(params) { 
							let rethtml = params.marker +params.name+"：" +params.value+' 百万'+data.unit ;
							return rethtml;
						}
					},
					xAxis: {
						type: 'category',
						data: date1,
					},
					colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#3975b8"], 
					yAxis: {
						type: 'value',
						name: '单位：百万'+data.unit,
					},
					series: [{
						data:value1,
						type: 'bar',
						barWidth:24,
					}]
				};
				chart.setOption(option);
				this.bus.$emit('loading',false);
			},
 
			//企业网址跳转
			geturl(url) {  
				if(url.indexOf('http')<0){
					url='http://'+url;
				}
				window.open(url);
				},
		}
	}
</script>

<style scoped>
	.enterprise_table{
		margin-bottom: 50px;
	}
	.endsm_title{
		border-left:8px solid #3e7bfa;line-height: 20px; padding-left:14px;margin: 10px 0 30px;
	}
</style> 
